import React, { useEffect, useState } from "react";
import axios from "axios";
import Cookies from "universal-cookie";
import { toast } from "react-toastify";
import {
  Autocomplete,
  Box,
  Pagination,
  TextField,
  Tooltip,
  Button,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { useSelector } from "react-redux";
import helpers from "../../../assets/js/helper";
import StyledDataGrid from "../GeneralComponents/StyledDataGrid";
import CircularIndeterminate from "../GeneralComponents/CirularProgress";
import { Host } from "../../../assets/js/Host";
import moment from 'moment';

import "../../../assets/css/DG.css";
import "../../../assets/css/AccordionStyle.css";

const cookies = new Cookies();

const Activity = () => {
  const currentDate = new Date();
  const options = { timeZone: "Asia/Baghdad" };
  const formattedDate = new Intl.DateTimeFormat("en-US", options).format(currentDate);

  const [rowsTotal, setRowsTotal] = useState(0);
  const [pageNumber, setPageNumber] = useState(1);
  const [pageCount, setPageCount] = useState(0);
  const [pageSize, setPageSize] = useState(20);
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [accExpansion, setAccExpansion] = useState(false);
  const [fromDate, setFromDate] = useState(() => {
    const curr = new Date();
    const first = curr.getDate() - curr.getDay();
    return new Date(curr.setDate(first));
  });
  
  const [toDate, setToDate] = useState(() => {
    const curr = new Date();
    const last = curr.getDate() - curr.getDay() + 6;
    return new Date(curr.setDate(last));
  });
  const [columns, setColumns] = useState([
    {
      headerName: "#",
      field: "id",
      flex: 1,
      minWidth: 100,
      maxWidth: 150,
      hide: false,
      renderCell: (rows) => (
        <Box
          sx={{
            padding: "0 5px",
          }}
        >
          {rows?.row?.index}
        </Box>
      ),
    },
    {
      headerName: "Log Type",
      field: "log_type_name",
      flex: 1.5,
      minWidth: 160,
      maxWidth: 250,
      hide: false,
      renderCell: (rows) => (
        <Box
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-end",
            padding: "0 5px",
          }}
        >
          <div style={{}}>{rows?.row?.log_type?.name}</div>
        </Box>
      ),
    },
    {
      headerName: "Creation Details",
      field: "creator",
      flex: 1,
      minWidth: 150,
      maxWidth: 150,
      hide: false,
      renderCell: (rows) => (
        <Box
          sx={{
            fontSize: "14px",
            padding: "0 5px",
            display: "flex",
            alignItems: "flex-end",
            flexDirection: "column",
          }}
        >
          <span>{rows?.row?.createdBy?.name}</span>
          <span style={{ fontSize: "11px" }}>
            {rows?.row?.created_at
              ? helpers.formatDate(rows?.row?.created_at) +
                " " +
                helpers.formatTime(rows?.row?.created_at)
              : null}
          </span>
        </Box>
      ),
    },
    {
      headerName: "Title",
      field: "name",
      flex: 4,
      minWidth: 150,
      maxWidth: 250,
      hide: false,
      renderCell: (rows) => (
        <Box
          sx={{
            width: "100%",
            display: "flex",
            // height:'100%',
            flexDirection: "column",
            alignItems: "flex-end",
            justifyContent: "flex-start",
            padding: "0 5px",
            fontColor: "#000",
            fontWeight: "500",
          }}
        >
          {rows?.row?.name}
        </Box>
      ),
    },
    {
      headerName: "Content",
      field: "note",
      flex: 10,
      minWidth: 500,
      // maxWidth: 650,
      hide: false,
      renderCell: (rows) => (
        <Box
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            padding: "0 5px",
            textAlign: "left",
            direction: "ltr",
            textOverflow: "ellipsis",
          }}
        >
          {rows?.row?.note?.length > 350 ? (
            <Tooltip title={rows?.row?.note}>
              <Box
                sx={{
                  textAlign: "left",
                }}
              >
                {rows?.row?.note?.slice(0, 350) + "..."}
              </Box>
            </Tooltip>
          ) : rows?.row?.note?.length > 0 ? (
            rows?.row?.note
          ) : (
            "---"
          )}
        </Box>
      ),
    },
  ]);
  const controller = new AbortController();
  const [searchName, setSearchName] = useState("");
  const [searchUserName, setSearchUserName] = useState("");
  const [searchEmail, setSearchEmail] = useState("");
  const [searchActive, setSearchActive] = useState(2);
  const [phone, setPhone] = useState("");
  const [users, setUsers] = useState([]);
  const [logTypes, setLogTypes] = useState([]);
  const [selectedLogTypes, setSelectedLogTypes] = useState([]);
  const [name, setName] = useState("");
  const [note, setNote] = useState("");
  const [activitableType, setActivitableType] = useState(null);
  const [activitableId, setActivitableId] = useState("");
  const [createdBy, setCreatedBy] = useState(null);
  const [activitiesList, setActivitiesList] = useState([
    {
      id: 1,
      lable: "الطلبات",
      name: "Order",
    },
    {
      id: 2,
      lable: "المركبات",
      name: "Vehicle",
    },
    {
      id: 3,
      lable: "المقبوضات",
      name: "Payment",
    },
    {
      id: 4,
      lable: "الفواتير",
      name: "Invoice",
    },
    {
      id: 5,
      lable: "الفواتير",
      name: "Invoice",
    },
    {
      id: 6,
      lable: "المستخدمين",
      name: "User",
    },
    {
      id: 7,
      lable: "المجموعات",
      name: "Group",
    },
    {
      id: 8,
      lable: "الصور",
      name: "Image",
    },
    {
      id: 9,
      lable: "جهات التكييل",
      name: "TakeelIssueSource",
    },
    {
      id: 10,
      lable: "انواع المركبات",
      name: "TransferType",
    },
    {
      id: 11,
      lable: "انواع الجهات",
      name: "EntityType",
    },
    {
      id: 12,
      lable: "الخدمات",
      name: "Service",
    },
    {
      id: 13,
      lable: "انواع الفواتير",
      name: "Report",
    },
    {
      id: 14,
      lable: "اعدادات المقبوضات",
      name: "PaymentSetting",
    },
    {
      id: 15,
      lable: "اعدادات الفواتير",
      name: "InvoiceSetting",
    },
  ]);

  const handleExpansion = (expansion) => setAccExpansion(expansion);
  
  const handlePageChange = (newPage) => {
    setPageNumber(newPage + 1);
  };

  const handelChangeDate = (date, number) => {
    if (number == 1) {
      setFromDate(date);
    } else if (number == 2) {
      setToDate(date);
    }
  };

  const loadData = async (type = "BROWSING") => {
    setLoading(true);
    var searchData = {
      name: name,
      note: note,
      log_type_ids: selectedLogTypes?.length
        ? selectedLogTypes?.map((item) => item?.id)
        : null,
    };

    try {
      const result = await axios({
        method: "GET",
        url: Host.API_URL + 'activities',
        headers: {
          'Authorization': 'Bearer ' + cookies.get('token')
        },
        params: {
          page: type === "SEARCH" ? 1 : pageNumber,
          page_size: pageSize,
          creation_date_from: fromDate ? moment(fromDate).format('YYYY-MM-DD') : null,
          creation_date_to: toDate ? moment(toDate).format('YYYY-MM-DD') : null,
          ...searchData,
          activityTypeName: activitableType ? activitableType?.name : null,
          activitable_id: activitableId ? activitableId : null,
          created_by_id: createdBy ? createdBy?.id : null,
        },
      });
      setLoading(false);
      if (result && result?.status) {
        setRows(
          result?.data?.data?.map((item, index) => {
            return {
              ...item,
              index: getCustomSequenceNumber(index, result?.data?.total),
            };
          })
        );
        setRowsTotal(result?.data?.total);
        setPageCount(Math.ceil(result?.data?.total / pageSize));
      } else {
        if (result?.errorMessage && typeof result?.errorMessage == "string") {
          toast.error(result?.errorMessage);
        } else {
          toast.error("Unknown Error Occured");
        }
      }
    } catch (err) {
      setLoading(false);
      console.log(err?.message);
    }
  };
  const getCustomSequenceNumber = (index, length) => {
    let number = pageNumber * pageSize + index + 1;
    return length - (number - 1);
  };

  useEffect(() => {
    loadData();
  }, [pageNumber, pageSize]);
  
  const handleSearchFunctions = () => {
    if (pageNumber > 1) {
      setPageNumber(1);
    } else {
      loadData("SEARCH");
    }
  };
  
  const handleClearFunctions = () => {
    setName("");
    setNote("");
    setSelectedLogTypes([]);
    setCreatedBy(null);
    setFromDate(formattedDate);
    setToDate(formattedDate);
    setActivitableType(null);
    setActivitableId("");
  };

  const exportToCSV = async () => {
    try {
      const result = await axios({
        method: "GET",
        url: Host.API_URL + 'activities',
        headers: {
          'Authorization': 'Bearer ' + cookies.get('token')
        },
        params: {
          page_size: rowsTotal,
          creation_date_from: fromDate ? moment(fromDate).format('YYYY-MM-DD') : null,
          creation_date_to: toDate ? moment(toDate).format('YYYY-MM-DD') : null,
          name: name,
          note: note,
          log_type_ids: selectedLogTypes?.length ? selectedLogTypes?.map((item) => item?.id) : null,
          activityTypeName: activitableType ? activitableType?.name : null,
          activitable_id: activitableId ? activitableId : null,
          created_by_id: createdBy ? createdBy?.id : null,
        },
      });
      if (result && result?.status) {
        // Here you would implement CSV export logic
        toast.success("Data exported successfully");
      }
    } catch (err) {
      toast.error("Export failed");
    }
  };

  useEffect(() => {
    loadData();
  }, [pageNumber, pageSize]);

  useEffect(() => {
    // Load initial data for dropdowns
    loadUsers();
    loadLogTypes();
  }, []);

  const loadUsers = async () => {
    try {
      const result = await axios({
        method: "GET",
        url: Host.API_URL + 'users',
        headers: {
          'Authorization': 'Bearer ' + cookies.get('token')
        },
      });
      if (result && result?.data) {
        setUsers(result.data.data || result.data);
      }
    } catch (err) {
      console.log('Error loading users:', err?.message);
    }
  };

  const loadLogTypes = async () => {
    try {
      const result = await axios({
        method: "GET",
        url: Host.API_URL + 'log-types',
        headers: {
          'Authorization': 'Bearer ' + cookies.get('token')
        },
      });
      if (result && result?.data) {
        setLogTypes(result.data.data || result.data);
      }
    } catch (err) {
      console.log('Error loading log types:', err?.message);
    }
  };

  return (
    <>
      <Box display="flex">
        <Accordion
          display="flex"
          sx={{ flexGrow: 4 }}
          onChange={(event, expansion) => handleExpansion(expansion)}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon sx={{ color: 'white' }} />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography>Advance Search</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Box
              component="span"
              display="flex"
              bgcolor="white"
              flexDirection="column"
              sx={{ borderRadius: 1 }}
            >
              <Box
                sx={{ m: 1 }}
                component="span"
                display="flex"
                bgcolor="white"
                flexDirection="row"
              >
                {/* <Box display="flex" sx={{ flexGrow: 2 }}>
                  <Autocomplete
                    sx={{ ml: 1 }}
                    fullWidth
                    options={users}
                    getOptionLabel={(option) => option.name || ""}
                    id="disable-close-on-select"
                    value={createdBy}
                    onChange={(e, v, r) => {
                      setCreatedBy(v ? v : null);
                    }}
                    renderInput={(params) => (
                      <TextField {...params} label="Created By" variant="outlined" />
                    )}
                  />
                </Box> */}
                {/* <Box display="flex" sx={{ flexGrow: 2 }}>
                  <Autocomplete
                    sx={{ ml: 1 }}
                    fullWidth
                    multiple
                    options={logTypes}
                    getOptionLabel={(option) => option.name || ""}
                    id="disable-close-on-select"
                    value={selectedLogTypes}
                    onChange={(e, v, r) => {
                      setSelectedLogTypes(v ? v : []);
                    }}
                    renderInput={(params) => (
                      <TextField {...params} label="Log Types" variant="outlined" />
                    )}
                  />
                </Box> */}
                <Box display="flex" sx={{ flexGrow: 1 }}>
                  <Button
                    variant="contained"
                    spacing={2}
                    sx={{ flexGrow: 1, margin: 1 }}
                    onClick={() => handleSearchFunctions()}
                  >
                    Search
                  </Button>
                  <Button
                    variant="contained"
                    spacing={2}
                    sx={{ flexGrow: 1, margin: 1 }}
                    color="secondary"
                    onClick={() => handleClearFunctions()}
                  >
                    Clear
                  </Button>
                </Box>
              </Box>
              <Box
                sx={{ m: 1 }}
                component="span"
                display="flex"
                bgcolor="white"
                flexDirection="row"
              >
                <TextField
                  sx={{ ml: 1 }}
                  fullWidth
                  label="Title"
                  variant="outlined"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
                <TextField
                  sx={{ ml: 1 }}
                  fullWidth
                  label="Content"
                  variant="outlined"
                  value={note}
                  onChange={(e) => setNote(e.target.value)}
                />
                {/* <Autocomplete
                  sx={{ ml: 1 }}
                  fullWidth
                  options={activitiesList}
                  getOptionLabel={(option) => option.lable || ""}
                  id="disable-close-on-select"
                  value={activitableType}
                  onChange={(e, v, r) => {
                    setActivitableType(v ? v : null);
                  }}
                  renderInput={(params) => (
                    <TextField {...params} label="Activity Type" variant="outlined" />
                  )}
                /> */}
              </Box>
              <Box
                sx={{ m: 1 }}
                component="span"
                display="flex"
                bgcolor="white"
                flexDirection="row"
              >
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DesktopDatePicker
                    label="From Date"
                    inputFormat="YYYY-MM-DD"
                    value={fromDate}
                    onChange={(date) => {
                      handelChangeDate(new Date(date), 1);
                    }}
                    renderInput={(params) => (
                      <TextField {...params} sx={{ ml: 1, width: "100%" }} />
                    )}
                  />
                  <DesktopDatePicker
                    label="To Date"
                    inputFormat="YYYY-MM-DD"
                    value={toDate}
                    onChange={(date) => {
                      handelChangeDate(new Date(date), 2);
                    }}
                    renderInput={(params) => (
                      <TextField {...params} sx={{ ml: 1, width: "100%" }} />
                    )}
                  />
                </LocalizationProvider>
                {/* <TextField
                  sx={{ ml: 1 }}
                  fullWidth
                  label="Activity ID"
                  variant="outlined"
                  value={activitableId}
                  onChange={(e) => setActivitableId(e.target.value)}
                /> */}
              </Box>
            </Box>
          </AccordionDetails>
        </Accordion>
      </Box>

      <div style={{ height: "calc(100% - 9em)" }}>
        <StyledDataGrid
          rows={rows}
          columns={columns}
          rowCount={rowsTotal}
          pageSize={pageSize}
          page={pageNumber - 1}
          onPageSizeChange={(newPageSize) => {
            setPageSize(newPageSize);
          }}
          rowsPerPageOptions={[5, 10, 20]}
          paginationMode="server"
          onPageChange={(params) => {
            handlePageChange(params);
          }}
        />
        <Box width="45%" m="auto">
          <Pagination
            color="primary"
            size="large"
            count={pageCount}
            page={pageNumber}
            showFirstButton
            showLastButton
            onChange={(e, p) => {
              setPageNumber(p);
            }}
          />
        </Box>
        <div
          style={{
            width: "50%",
            position: "absolute",
            top: "100px",
            margin: "0 auto",
            left: "50%",
            top: "50%",
          }}
        >
          {loading && <CircularIndeterminate />}
        </div>
      </div>
    </>
  );
};

export default Activity;
